<template>
  <div class="content-wrapper">
    <b-container fluid class="no-padding">
      <h4 class="card-title">{{$t('Sensor List')}}</h4>
      <!-- User Interface controls -->
      <div class="print_hide" style="background-color: #e8f4f9;padding: 15px 15px 0;">
        <b-row>
          <b-col lg="12" class="my-1">
          <h4 class="pl-1">{{ $t('Filters') }}</h4>
          </b-col>
          <b-col lg="4" class="my-1" v-if="$store.state.user.data.role !== 'System Admin'">
            <b-form-group
              :label="$t('Company')"
              label-for="appliance-input"
            >
              <b-form-select
                @change="fetchGroups"
                size="sm"
                v-model="filters.categoryId"
                :options="[{value: null, text: 'All'}].concat($store.state.categories.map(category => ({ value: category.id, text: category.name })))"
                required
              ></b-form-select>
<!--              <div v-show="$v.filters.labelType.$error" class="text-danger"> {{ $t('This is a required field.') }}-->
<!--              </div>-->
            </b-form-group>
          </b-col>
          <b-col v-if="filters.categoryId && $store.state.user.data.role !== 'System Admin'" lg="4" class="my-1">
            <b-form-group
              :label="$t('Group')"
              label-for="appliance-input"
            >
              <b-form-select
                size="sm"
                v-model="filters.groupId"
                :options="groupList"
                required
              ></b-form-select>
              <!--              <div v-show="$v.filters.labelType.$error" class="text-danger"> {{ $t('This is a required field.') }}-->
              <!--              </div>-->
            </b-form-group>
          </b-col>
          </b-row>
          <b-row>
          <b-col lg="4" class="my-1">
            <b-form-group
              :label="$t('Device ID')"
              label-for="appliance-input"
            >
              <b-form-input
                v-model="filters.gatewayId"
                type="search"
                :placeholder="$t('Device ID')"
              ></b-form-input>
              <!--              <div v-show="$v.filters.labelType.$error" class="text-danger"> {{ $t('This is a required field.') }}-->
              <!--              </div>-->
            </b-form-group>
          </b-col>
          <b-col lg="4" class="my-1">
            <b-form-group
              :label="$t('Sensor ID')"
              label-for="appliance-input"
            >
              <b-form-input
                v-model="filters.sensorId"
                type="search"
                :placeholder="$t('Sensor ID')"
              ></b-form-input>
              <!--              <div v-show="$v.filters.labelType.$error" class="text-danger"> {{ $t('This is a required field.') }}-->
              <!--              </div>-->
            </b-form-group>
          </b-col>

          <b-col lg="12" class="my-1">

            <b-btn style="float:right;color:white;margin-bottom: 15px; margin-top: 15px;" variant="light"
                   @click="fetchDevices()"><i class="fa fa-search"></i>{{ $t('Search') }}
            </b-btn>
          </b-col>
        </b-row>
      </div>
      <b-table
        show-empty
        hover
        responsive
        :busy="devicesTableIsBusy"
        :items="devices"
        :fields="deviceFields"
        :current-page="devicePage"
        :per-page="perPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :sort-compare="customCompare"
      >
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <strong class="text-primary">Loading...</strong>
          </div>
        </template>
        <template v-slot:cell(company)="row">
          <b-link class="nav-link" :to="'/companies/'+row.item.company"> {{getCompanyName(row.item.company)}} </b-link>

        </template>
        <template v-slot:cell(gatewayId)="row">
          {{ row.item.gatewayId }} <br> {{row.item.gatewayName}}
        </template>
        <template v-slot:cell(category)="row">
          <b-link v-if="$store.state.user.data.role === 'System Admin'" class="nav-link" :to="'/companies/'+row.item.company+'/category/'+row.item.category">  {{$store.state.categories.find( c => c.id === row.item.category).name}} </b-link>
          <b-link v-else class="nav-link" :to="'/company/'+row.item.category">  {{$store.state.categories.find( c => c.id === row.item.category).name}} </b-link>
        </template>
        <template v-slot:cell(group)="row">
          <b-link v-if="$store.state.user.data.role === 'System Admin'" class="nav-link" :to="'/companies/'+row.item.company+'/group/'+row.item.group+'#devices'"> Go to Group Devices </b-link>
          <b-link v-else class="nav-link" :to="'/group/'+row.item.group"> {{$store.state.groups.find( c => c.id === row.item.group).name}} </b-link>
        </template>
        <template v-slot:cell(sensorId)="row">
          {{ row.item.sensorId }} <br> {{row.item.sensorName}}
        </template>
        <template v-slot:cell(isActive)="row">
          <label :class="row.item.isActive === 'true' ? ' badge badge-success' : 'badge badge-danger'"
                 style="text-align: center;">{{
              $t(row.item.isActive === "true" ? 'Active' : 'Not Active')
            }}</label>
        </template>

        <template v-slot:cell(status)="row">
<!--          Not implemented-->
          <label :class="row.item.status ? ' badge badge-success' : 'badge badge-danger'"
                 style="text-align: center;">{{
              $t(row.item.status ? 'Recording' : 'N/A')
            }}</label>
        </template>

<!--        <template v-slot:cell(actions)="row">-->
<!--          &lt;!&ndash;<b-button variant="outline-primary" size="sm" @click="mapCloneForm(row.item.id)">&ndash;&gt;-->
<!--          &lt;!&ndash;{{$t('Clone')}}&ndash;&gt;-->
<!--          &lt;!&ndash;</b-button>&ndash;&gt;-->
<!--          <b-button v-if="$store.state.user.data.role === 'System Admin'" variant="outline-primary" size="sm"-->
<!--                    @click="addSensorModal(row.item.gatewayId)">-->
<!--            {{ $t('Add Sensor') }}-->
<!--          </b-button>-->
<!--          <b-button v-if="['System Admin', 'Administrator', 'Manager'].includes($store.state.user.data.role)"-->
<!--                    variant="outline-primary" size="sm" @click="mapDeviceUpdate(row)">-->
<!--            {{ $t('Edit') }}-->
<!--          </b-button>-->
<!--          <b-button v-if="$store.state.user.data.role === 'System Admin'" variant="outline-danger" size="sm"-->
<!--                    @click="deleteSensor(row.item.gatewayId, 'gateway')">-->
<!--            {{ $t('Remove') }}-->
<!--          </b-button>-->
<!--        </template>-->
      </b-table>
      <b-pagination
        v-model="devicePage"
        :total-rows="devices.length"
        :per-page="perPage"
        align="center"
        class="my-5"
      ></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Devices',
  props: {
    // 'categories': {
    //   type: Array,
    //   default: []
    // }
  },
  data () {
    return {
      categories: [],
      sortBy: '',
      categoriesList: [
        {value: null, text: 'All'}
      ],
      sortDesc: false,
      groups: [],
      groupList: [
        {value: null, text: 'All'}
      ],
      sortDirection: 'asc',
      perPage: 20,
      devicesTableIsBusy: false,
      devices: [],
      devicePage: 1,
      filters: {
        categoryId: null,
        groupId: null,
        sensorId: null,
        gatewayId: null
      }
    }
  },
  computed: {
    deviceFields () {
      let fields = []
      if (this.$store.state.user.data.role === 'System Admin') {
        fields.push({
          key: 'company',
          label: this.$t('Company'),
          sortable: true,
          sortDirection: 'asc',
          class: 'text-left'
        })
      }

      fields.push({key: 'gatewayId', label: this.$t('Device'), sortable: true, sortDirection: 'desc', class: 'text-left'})
      // {key: 'gatewayName', label: this.$t('Device Name'), sortable: true, sortDirection: 'desc', class: 'text-left'},
      fields.push({key: 'status', label: this.$t('Status'), sortable: true, class: 'text-center'})
      fields.push({key: 'sensorId', label: this.$t('Sensor ID'), sortable: true, sortDirection: 'desc', class: 'text-left'})
      if (this.$store.state.user.data.role !== 'System Admin') {
        fields.push({key: 'category', label: this.$t('Category'), sortable: true, sortDirection: 'desc', class: 'text-left'})
      }
      fields.push({key: 'group', label: this.$t('Group'), sortable: true, sortDirection: 'desc', class: 'text-left'})
      fields.push({key: 'isActive', label: this.$t('Active'), sortable: true, class: 'text-center'})
      // {key: 'actions', label: this.$t('Actions'), class: 'text-center'}

      return fields
    }
  },
  async mounted () {
    if (this.$store.state.companies.length === 0) {
      await this.$store.dispatch('fetchCompanies')
    }
    if (this.$store.state.user.data.role !== 'System Admin') {
      await this.fetchCategories()
      await this.$store.dispatch('fetchGroups')
    }
    this.fetchDevices()
  },
  methods: {
    getCompanyName (id) {
      const company = this.$store.state.companies.find(c => c.id === id)
      if (company) {
        return company.name
      }
      return ''
    },
    fetchGroups (all = false) {
      if (this.$store.state.user.data.role === 'System Admin') {
        return
      }
      this.groupList = [{value: null, text: 'All'}]
      let self = this
      this.groups = []

      var groupsQuery = ''
      if (all === true) {
        var company = this.$store.state.user.data.companyId
        groupsQuery = this.$firebase.firestore().collectionGroup('groups').where('companyId', '==', company)
      } else {
        if (!this.filters.categoryId) { return }
        groupsQuery = this.$firebase.firestore().collectionGroup('groups').where('categoryId', '==', this.filters.categoryId)
      }

      groupsQuery.get().then(function (querySnapshot) {
        querySnapshot.forEach(async function (doc) {
          var groupData = doc.data()
          groupData.id = doc.id
          self.groups.push(groupData)
          self.groupList.push({value: doc.id, text: groupData.name})
        })
      })
    },
    async fetchCategories () {
      this.categoriesList = [{value: null, text: 'All'}]
      await this.$store.dispatch('fetchCategories')
      // console.log('length', this.$store.state.categories.length)
      // this.$store.state.categories.forEach(category => {
      //   this.categoriesList.push({value: category.id, text: category.name})
      // }, this)
      console.log('categories', this.$store.state.categories)
    },
    fetchDevices () {
      console.log('fetching')
      var self = this

      let company = ''
      if (this.$store.state.user.data.role !== 'System Admin') {
        company = this.$store.state.user.data.companyId

        if (this.$store.state.user.data.role !== 'Administrator') {
          this.filters.groupId = this.$store.state.user.data.groups
        }
      }

      this.devicesTableIsBusy = true
      let params = {
        'group': this.filters.groupId ? this.filters.groupId : null,
        'category': this.filters.categoryId ? this.filters.categoryId : null,
        'company': company,
        'gatewayId': this.filters.gatewayId,
        'sensorId': this.filters.sensorId
      }

      // if (this.$route.params.id != null) {
      //   params.company = this.$route.params.id
      // } else {
      //   params.company = this.$store.state.user.data.companyId
      // }

      console.log(params)
      const getDevices = this.$firebase.functions().httpsCallable('getSensorList')

      getDevices(params).then(async function (result) {
        // success or error handling
        console.log('result', result)
        if (!result.hasOwnProperty('data')) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.devices = result.data
          await self.getRecordingStatus()
        }
        self.devicesTableIsBusy = false
        self.loading = false
      }).catch(function (err) {
        console.log('Failed to fetch Gateways', err)
      })
    },
    async getRecordingStatus () {
      for (var i = 0; i < this.devices.length; i++) {
        if (this.devices[i].isActive) {
          this.devices[i].status = await this.isSensorRecording(this.devices[i].company, this.devices[i].group, this.devices[i].sensorId, this.devices[i].publishTimeout)
        }
        console.log(this.devices[i])
      }
    },
    async isSensorRecording (company, group, sensorId, publishTimeout) {
      const minutes = (+publishTimeout) + 1
      console.log('minutes', minutes)
      const lastRecordingDate = moment().add(-(minutes), 'minutes').toDate()
      const firTimestamp = this.$firebase.firestore.Timestamp.fromDate(lastRecordingDate)
      const doc = await this.$firebase.firestore()
        .collection('companies').doc(company)
        .collection('groups').doc(group)
        .collection('temperatureLogs')
        .where('deviceId', '==', sensorId)
        .where('timestamp', '>=', firTimestamp)
        .orderBy('timestamp', 'desc')
        .limit(1)
        .get()
      console.log('isSensorRecording========', !doc.empty)
      return !doc.empty
    },
    showDevice (item) {
      // this.showDeviceBool = true
      // this.fetchDeviceSensors(item.gatewayId)
      // this.deviceShown = {
      //   gatewayId: item.gatewayId,
      //   gatewayName: item.gatewayName
      // }
    },
    deleteSensor (id, type) {
      // var self = this
      // this.$bvModal.msgBoxConfirm(self.$t('You are about to delete this Sensor. This action cannot be undone.'),
      //   {
      //     title: self.$t('Are you sure?'),
      //     okVariant: 'danger',
      //     okTitle: 'Confirm',
      //     centered: true
      //   })
      //   .then(value => {
      //     self.loading = true
      //     if (value) {
      //       const removeDevice = this.$firebase.functions().httpsCallable('deleteDevice')
      //
      //       removeDevice({'deviceId': id}).then(function (result) {
      //         // success or error handling
      //         console.log('result', result)
      //         if (result) {
      //           if (type === 'sensor') {
      //             self.fetchDeviceSensors(self.deviceShown.gatewayId)
      //           } else {
      //             self.fetchSensors()
      //           }
      //           self.$swal({
      //             title: self.$t('Deleted!'),
      //             type: 'success',
      //             timer: 1000,
      //             showConfirmButton: false
      //           })
      //         } else {
      //           self.$swal({
      //             title: self.$t('There was an error!'),
      //             text: '',
      //             type: 'error',
      //             timer: 0,
      //             showConfirmButton: false
      //           })
      //         }
      //         self.loading = false
      //       })
      //     }
      //   })
      //   .catch(err => {
      //     // An error occurred
      //     console.log(err)
      //     self.loading = false
      //   })
    },
    mapDeviceUpdate (row) {
      // var self = this
      //
      // this.deviceForm = JSON.parse(JSON.stringify(row.item))
      // console.log('sensor', self.newForm)
      // this.deviceModalTitle = this.$t('Update Device')
      // this.deviceAction = 'updateGateway'
      // this.$bvModal.show('new-device-form')
    },
    addSensorModal (deviceId) {
      // var self = this
      // self.sensorModalTitle = this.$t('Add New Sensor')
      // this.sensorAction = 'addSensor'
      // this.sensorForm.gatewayId = deviceId
      // this.$bvModal.show('modal-sensor-form')
    },
    customCompare (a, b, key) {
      if (['date', 'time', 'dateIn', 'dateOut', 'createdAt', 'createdAtFormatted', 'updatedAtFormatted'].includes(key)) {
        var aDate = moment(a[key], 'DD/MM/YYYY kk:mm')
        var bDate = moment(b[key], 'DD/MM/YYYY kk:mm')
        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1
          } else if (aDate > bDate) {
            return 1
          } else {
            return 0
          }
        }
        return null
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Devices.vue